<template>
  <div>
    <kfkc-census />
  </div>
</template>

<script>
// 获取接口地址
import KfkcCensus from '../components/tjbb/kfkcCensus.vue'

export default {
  name: 'Kfkctj',
  components: {
    // sideMenu,
    // Header,
    KfkcCensus
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
